import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

const NotFound = () => (
  <div className="max-w-5xl mx-auto px-6 py-20" data-testid="not-found-page">
    <Seo title="Page introuvable | Fast Alu" description="La page demandée n’existe pas." />
    <h1 className="font-heading text-4xl uppercase" data-testid="not-found-title">
      Page introuvable
    </h1>
    <p className="text-brand-ink/70 mt-4" data-testid="not-found-text">
      La page demandée n’existe pas ou a été déplacée.
    </p>
    <Link
      to="/"
      className="inline-flex mt-6 bg-brand-red text-white px-5 py-3 rounded-sm uppercase text-xs font-bold"
      data-testid="not-found-home-link"
    >
      Retour à l’accueil
    </Link>
  </div>
);

export default NotFound;
